import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {IStore} from '../../../../shared/shared-models/store/store';
import {Store} from '@ngrx/store';
import {INotification, INotificationChips, INotificationPerStore} from '../../models';
import {
  selectAllNotifications,
  selectFilterChips,
  selectIsUserScrollGetLoading,
  selectNotificationLastDocumentId,
  selectSelectedNotification,
} from '../../store/notification.selectors';
import {IUser} from '../../../user-access/models';
import {getStoreSuppliersByUserSelectedStore} from '../../../core/store-shared/shared.actions';
import {selectUser} from '../../../user-access/user-store/user.selectors';
import {selectStores} from '../../../user-access/user-stores-store/user-store.selectors';
import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';
import {IconColourEnum} from '../../../../shared-modules/shared-icons/models/icons-colour.enum';

@Component({
    selector: 'app-notification-modal-container',
    templateUrl: './notification-modal-container.component.html',
    styleUrls: ['./notification-modal-container.component.scss'],
    standalone: false
})
export class NotificationModalContainerComponent implements OnInit {

  selectedStoresDropdown: string[] = [];

  filterChips$: Observable<INotificationChips>;
  isUserScrollLoading$: Observable<boolean>;
  lastDocumentId$: Observable<string | null>;
  notifications$: Observable<Record<string, INotificationPerStore>>;
  userSelectedNotification$: Observable<INotification>;
  user$: Observable<IUser>;
  userStores$: Observable<IStore[]>;

  markAllAsReadTrigger = false;

  protected readonly icons = IconsEnum;
  protected readonly iconColourEnum = IconColourEnum;

  constructor(
    private readonly store: Store,
  ) {
  }

  get getIsMarkAllAsReadDisabled(): boolean {
    return this.markAllAsReadTrigger || this.selectedStoresDropdown.length < 1;
  }

  ngOnInit(): void {
    this.store.dispatch(getStoreSuppliersByUserSelectedStore({dispatch: false}));
    this.filterChips$ = this.store.select(selectFilterChips);
    this.isUserScrollLoading$ = this.store.select(selectIsUserScrollGetLoading);
    this.lastDocumentId$ = this.store.select(selectNotificationLastDocumentId);
    this.notifications$ = this.store.select(selectAllNotifications);
    this.user$ = this.store.select(selectUser);
    this.userStores$ = this.store.select(selectStores);
    this.userSelectedNotification$ = this.store.select(selectSelectedNotification);
  }

  onMarkAllAsRead(): void {
    if (!this.getIsMarkAllAsReadDisabled) {
      this.markAllAsReadTrigger = true;
    }
  }

  onSelectedStoresChange(stores: string[]): void {
    this.selectedStoresDropdown = stores;
  }

}
